export const BASE_URL = 'https://minotes-lqzw.onrender.com'
// export const BASE_URL = 'http://localhost:5000'